import { render } from "./newschedule.vue?vue&type=template&id=2fcf4dc2"
import script from "./newschedule.vue?vue&type=script&lang=js"
export * from "./newschedule.vue?vue&type=script&lang=js"

import "./newschedule.vue?vue&type=style&index=0&id=2fcf4dc2&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__